import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { deleteCoupaFilesById } from "../../service/deleteCoupaFilesById";
import {
  deleteCoupaFilesSuccess,
  deleteCoupaFilesFailure,
} from "../reducers/drmCoupaDeleteSlice";

export function* workerDeleteCoupaFiles({ payload }) {
  const controller = new AbortController();
  try {
    const response = yield call(deleteCoupaFilesById, [payload, controller]);
    const message = response?.data?.message || "Coupa files deleted successfully.";
    yield put(deleteCoupaFilesSuccess(message));
  } catch (error) {
    const message =
      error?.response?.data?.message || error?.message || "Unable to delete Coupa files.";
    yield put(deleteCoupaFilesFailure(message));
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

function* drmCoupaDeleteSaga() {
  yield takeLatest("drmCoupaDelete/deleteCoupaFilesStart", workerDeleteCoupaFiles);
}

export default drmCoupaDeleteSaga;
